// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__h_CPV","header":"MergedInvoice_header__28SX4"};